import { isAfter } from "date-fns"

export const useAuthenticatedUser = (user: any) => {
  if (!user?.id_token_expiration) return false

  const expirationString = user.id_token_expiration.endsWith("Z")
    ? user.id_token_expiration
    : user.id_token_expiration + "Z"

  const expirationDate = new Date(expirationString)
  const now = new Date()

  const authenticatedUser = Boolean(user && isAfter(expirationDate, now))

  return authenticatedUser
}